import React from "react";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { ORDER_TYPES } from "@/lib/reportFilters";

export default function OrderTypeFilter({ value, onChange, className, testId = "report-order-type" }) {
  return (
    <div className={className}>
      <Label className="text-[12px] text-slate-600 mb-1 block">Order type</Label>
      <Select value={value || "all"} onValueChange={onChange}>
        <SelectTrigger
          className="h-9 w-[180px]"
          data-testid={testId}
          data-report-filter
          data-report-filter-label="Order type"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {ORDER_TYPES.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
